import 'assets/styles/index.scss';

import Head from 'next/head';
import Script from 'next/script';
import {parseCookies, setCookie} from 'nookies'
import posthog from 'posthog-js'
import { PostHogProvider} from 'posthog-js/react'
import StoreProvider from 'ui/containers/StoreContext';
import { FEATURE_FLAG } from 'utils/consts';

import CanonicalUrl from './components/CanonicalURL';
import ErrorBoundary from './containers/ErrorBoundary';
import GridProvider from './containers/LayoutContext';
import ErrorPageLayout from './layouts/ErrorPageLayout';
import RouteProgressBar from './layouts/RouteProgressBar';

if (typeof window !== 'undefined') {
  const cookie = parseCookies()
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_API_KEY, {
    capture_pageleave: false,
    capture_pageview: false,
    bootstrap: {
      isIdentifiedID: true,
      bootstrap: {
        distinctID: cookie.distinctId || undefined,
        isIdentifiedID: true,
      },
    },
    loaded: (ph) => {
      if (!sessionStorage.getItem('pageview')) {
        ph.capture('$pageview')
        sessionStorage.setItem('pageview', 'true')
      }
      setCookie(null, 'distinctId', posthog.get_distinct_id())
      ph.onFeatureFlags(() => {
        const featureFlag = ph.getFeatureFlag(FEATURE_FLAG)
        if (featureFlag) {
          setCookie(null, FEATURE_FLAG, featureFlag)
        } 
      })
    },
  });
}

function PostHogWrapper({ children }) {
  return typeof window !== 'undefined' ? (
    <PostHogProvider client={posthog}>
      {children}
    </PostHogProvider>
  ) : (
    <>
      {children}
    </>
  )
}

function App({
  children,
  title = 'My Personality',
  gtmKey = null,
  posthogKey = null,
  initialState,
}) {
  return (
    <>
      <Head>
        <title>{title}</title>
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-touch-icon.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicon-16x16.png"
        />
        <link rel="manifest" href="/site.webmanifest" />
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#36a195" />
        <meta name="msapplication-TileColor" content="#36a195" />
        <meta name="theme-color" content="#ffffff" />
      </Head>
      <CanonicalUrl />
      {gtmKey && (
        <Script
          strategy="lazyOnload"
          id="GTM"
          dangerouslySetInnerHTML={{
            __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${gtmKey}');`,
          }}
        />
      )}
      <Script strategy="lazyOnload" id="accessiby" dangerouslySetInnerHTML={{
        __html: `(function(){ var s = document.createElement('script'), e = ! document.body ? document.querySelector('head') : document.body; s.src = 'https://acsbapp.com/apps/app/dist/js/app.js'; s.async = true; s.onload = function(){ acsbJS.init({ statementLink : '', footerHtml : '', hideMobile : true, hideTrigger : true, language : 'en', position : 'left', leadColor : '#146ff8', triggerColor : '#146ff8', triggerRadius : '50%', triggerPositionX : 'right', triggerPositionY : 'bottom', triggerIcon : 'people', triggerSize : 'medium', triggerOffsetX : 20, triggerOffsetY : 20, mobile : { triggerSize : 'small', triggerPositionX : 'right', triggerPositionY : 'bottom', triggerOffsetX : 10, triggerOffsetY : 10, triggerRadius : '50%' } }); }; e.appendChild(s);}());`
      }} />
      <noscript
        dangerouslySetInnerHTML={{
          __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-55GZ2MR"
          height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
        }}
      />
      <ErrorBoundary
        fallback={
          <ErrorPageLayout
            title="Something went wrong"
            subtitle=""
            text="Our developers will fix it"
          />
        }
      >
        <PostHogWrapper apiKey={posthogKey}>
          <StoreProvider initialState={initialState}>
            <RouteProgressBar />
            <GridProvider>{children}</GridProvider>
          </StoreProvider>
        </PostHogWrapper>
      </ErrorBoundary>
      <div id="portals"></div>
    </>
  );
}

export default App;
